import React from "react";
import Styles from "./styles.module.scss";
import { useTranslation } from "react-i18next";
import {useSelector} from "react-redux";

const CabinetPartnersLevel = () => {
    const { t } = useTranslation();

    const partnersMainData = useSelector(store => store.cabinet.partnersMainData);

    const getQualificationProgress = (data) => {
        if (!data?.current_rank || !data?.next_rank) {
            return null;
        }

        const points = Number(data?.points);
        const currentMinPoints = Number(data?.current_rank?.min_points);
        const nextMinPoints = Number(data?.next_rank?.min_points);

        if (
            !Number.isFinite(points) ||
            !Number.isFinite(currentMinPoints) ||
            !Number.isFinite(nextMinPoints)
        ) {
            return null;
        }

        if (nextMinPoints <= currentMinPoints) {
            return 100;
        }

        const progress = ((points - currentMinPoints) / (nextMinPoints - currentMinPoints)) * 100;

        return Math.min(Math.max(progress, 0), 100);
    };

    const qualificationProgress = getQualificationProgress(partnersMainData);

    return (
        <div className={Styles.container}>
            <div className={`${Styles.contentWrap} ${Styles.cabinetCard}`}>
                <div className={Styles.level}>{t('Ваша квалификация')} - {partnersMainData?.current_rank?.name}</div>
                <div className={`${Styles.statWrap}`}>
                    <div className={`${Styles.statWrapItem}`}>
                        <div className={`${Styles.statWrapItemName}`}>{t('Прогресс квалификации')}</div>
                        <div className={`${Styles.statWrapItemValue}`}>{qualificationProgress === null ? "—" : `${qualificationProgress.toFixed(0)}%`}</div>
                    </div>
                    <div className={`${Styles.statWrapItem}`}>
                        <div className={`${Styles.statWrapItemName}`}>{t('Следующий уровень')}</div>
                        <div className={`${Styles.statWrapItemValue}`}>{partnersMainData?.next_rank?.name || '-'}</div>
                    </div>
                </div>
                <div className={`${Styles.noteLink}`}>{t('Узнать больше о квалификации')}</div>
            </div>
        </div>
    );
};

export default CabinetPartnersLevel;